export default {
    meta: {
        title: '历史拓店任务详情',
        url: '/standardstore/historytaskdetail',
        urlName: '标准版拓店-拓店任务'
    }
};
